import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const getCurrentAdminUser = unaryRpc({
  name: "getCurrentAdminUser" as const,
  description:
    "Resolve the signed-in admin's email to their Mongo user record, for features that must attribute a write to a real user id.",
  input: z.object({}),
  output: z.object({
    emailAddress: z.string(),
    userId: z.string().nullable(),
    name: z.string().nullable(),
  }),
});

export type GetCurrentAdminUserOutput = z.infer<
  typeof getCurrentAdminUser.output
>;
